import { render, staticRenderFns } from "./SuiteAssignments.vue?vue&type=template&id=18cd71b6&scoped=true"
import script from "./SuiteAssignments.vue?vue&type=script&lang=ts"
export * from "./SuiteAssignments.vue?vue&type=script&lang=ts"
import style0 from "./SuiteAssignments.vue?vue&type=style&index=0&id=18cd71b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cd71b6",
  null
  
)

export default component.exports